import gsap from 'gsap'

export default function initMenus() {
	toggleMenu()
	toggleMobileSubMenu()

	// TOGGLE STATE OF MOBILE MENU
	function toggleMenu() {
		const menuButtons = document.querySelectorAll('[data-toggle-menu]')
		const mainElement = document.querySelector('main')
		const staggerContainers = document.querySelectorAll('[data-stagger-items]')

		menuButtons.forEach(btn => {
			btn.addEventListener('click', () => {
				document.body.classList.toggle('menu-open')
				document.documentElement.classList.toggle('overflow-hidden')
				syncMenuState()

				if (document.body.classList.contains('menu-open')) {
					staggerContainers.forEach(stagger => {
						const elementsStagger = gsap.utils.toArray(stagger.children)

						gsap.from(elementsStagger, {
							y: 20,
							opacity: 0,
							delay: 0.25,
							stagger: 0.1,
						})
					})
				}
			})
		})

		mainElement.addEventListener('click', () => {
			if (document.body.classList.contains('menu-open')) {
				closeMenu()
			}
		})

		document.addEventListener('keydown', e => {
			if (e.key === 'Escape' && document.body.classList.contains('menu-open')) {
				closeMenu()
			}
		})
	}

	// TOGGLE THE MOBILE SUB MENU
	function toggleMobileSubMenu() {
		const toggles = document.querySelectorAll('[data-toggle-mobile-sub-menu]')

		toggles.forEach(toggle => {
			toggle.addEventListener('click', () => {
				const parentEl = toggle.closest('[data-mobile-menu-item]')
				const subMenu = parentEl.querySelector('[data-mobile-sub-menu]')

				// Doesn't exist, bail early
				if (!subMenu) {
					return
				}

				subMenu.classList.toggle('hidden')
				toggle.setAttribute('aria-expanded', String(!subMenu.classList.contains('hidden')))

				const plusIcon = toggle.querySelector('[data-icon-plus]')
				const closeIcon = toggle.querySelector('[data-icon-close]')
				if (plusIcon && closeIcon) {
					plusIcon.classList.toggle('hidden')
					closeIcon.classList.toggle('hidden')
				}
			})
		})
	}
}

export function closeMenu() {
	document.body.classList.remove('menu-open')
	document.documentElement.classList.remove('overflow-hidden')
	syncMenuState()
}

// KEEP THE MENU OUT OF THE A11Y TREE / TAB ORDER WHILE IT'S OFF SCREEN
function syncMenuState() {
	const isOpen = document.body.classList.contains('menu-open')
	const menu = document.querySelector('[data-menu]')

	if (menu) {
		menu.inert = !isOpen
	}

	document.querySelectorAll('[data-toggle-menu]').forEach(btn => {
		btn.setAttribute('aria-expanded', String(isOpen))
	})
}
